import { getSupplierAgingRows, getSupplierAgingColumns } from "./supplier-aging-statement";
import { AgingSummary } from "./aging-statement";
import { getConsolidatedSupplierAging, getConsolidatedSupplierAgingSummary } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";

// Every supplier unless one is picked, every document type unless one is picked.
const supplierAgingFilters = {
  SupplierId: "*",
  Type: "All",
};

const supplierAgingFilterOptions = [
  { key: "supplierId", apiKey: "SupplierId" },
  { key: "type", apiKey: "Type" },
];

// Totals over every supplier that matches the filters, not just the page
// (ConsolidatedSupplierAgingSummaryReport).
const summaryTiles = [
  { key: "totalTotal", label: "Total Outstanding", highlight: true },
  { key: "suppliers", label: "Suppliers", isCount: true },
  { key: "notDueTotal", label: "Not Due" },
  { key: "30DaysTotal", label: "1-30 Days" },
  { key: "60DaysTotal", label: "31-60 Days" },
  { key: "90DaysTotal", label: "61-90 Days" },
  { key: "120DaysTotal", label: "91-120 Days", late: true },
  { key: "over120To365DaysTotal", label: "121-365 Days", late: true },
  { key: "over12To18MonthsTotal", label: "12-18 Months", late: true },
  { key: "over18To24MonthsTotal", label: "18-24 Months", late: true },
  { key: "over2To3YearsTotal", label: "2-3 Years", late: true },
  { key: "over3YearAndAboveTotal", label: "Over 3 Years", late: true },
  { key: "advancePaymentTotal", label: "Unapplied Advances" },
  { key: "netTotal", label: "Net Outstanding" },
];

export default function ReportSupplierAging({ activeCompany }) {
  return (
    <DynamicReport
      reportName="supplier-aging"
      activeCompany={activeCompany}
      columnsDataProvider={getSupplierAgingColumns}
      rowsDataProvider={getSupplierAgingRows}
      fetchData={getConsolidatedSupplierAging}
      fetchSummary={getConsolidatedSupplierAgingSummary}
      renderSummary={(summary) => <AgingSummary summary={summary} tiles={summaryTiles} />}
      exportUrl="procurement/reports/supplier/consolidated-aging/xls"
      filtersInitialState={supplierAgingFilters}
      filterOptions={supplierAgingFilterOptions}
      orderBy="SupplierName"
      showDateFilter
      showDateRangeFilter={false}
    />
  );
}
